import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const UnionIcon = withSvgIcon(
    <g>
        <path d="M204.4,82.1v-77H3.6v200.8h80v77h200.8V82.1H204.4z M204.4,205.9V90.1h72v184.8H91.6v-69H204.4z M196.4,13.1 v184.8H11.6V13.1H196.4z" />
    </g>,
    "0 0 288 288"
);
